import { useEffect, useState } from "react";
import { Gift, Bell, BellRing, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { WaitlistBrandPicks } from "@/components/rewards/WaitlistBrandPicks";

const PATH = "/rewards/gift-cards/waitlist";

export const GiftCardsComingSoon = () => {
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(false);
  const joined = info ? info.joined : null;

  useEffect(() => {
    api.get(PATH).then((r) => setInfo(r.data)).catch(() => setInfo({ joined: false, brands: [], picks: [] }));
  }, []);

  const toggle = async () => {
    setBusy(true);
    try {
      const r = joined ? await api.delete(PATH) : await api.post(PATH);
      setInfo(r.data);
      toast.success(r.data.joined ? "You're on the list. We'll tell you first." : "You've left the waitlist.");
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="mt-10 pf-card p-6 md:p-8 bg-gradient-to-br from-cyan-50 via-white to-emerald-50 border-cyan-200/70"
             data-testid="gift-cards-coming-soon">
      <div className="flex flex-col md:flex-row md:items-center gap-6">
        <div className="w-14 h-14 rounded-2xl bg-white border border-cyan-200 flex items-center justify-center text-cyan-700 shrink-0">
          <Gift className="w-6 h-6" />
        </div>
        <div className="flex-1">
          <div className="text-[10px] uppercase tracking-widest text-cyan-700 font-semibold">Coming soon</div>
          <h2 className="font-display text-2xl text-slate-900 mt-1">Gift cards are on the way</h2>
          <p className="text-sm text-slate-600 mt-2 max-w-xl leading-relaxed">
            Soon you'll be able to trade your available cashback for brand gift cards. Your cashback keeps
            building in the meantime.
          </p>
          {joined && (
            <p className="text-xs text-emerald-700 font-semibold mt-3" data-testid="gift-cards-waitlist-joined">
              You're on the list. We'll email you and send a notice here as soon as gift cards launch.
            </p>
          )}
        </div>
        <button onClick={toggle} disabled={busy || joined === null}
                className={`shrink-0 inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold transition-colors disabled:opacity-60 ${joined
                  ? "border border-slate-300 text-slate-700 bg-white hover:bg-slate-50"
                  : "bg-slate-900 text-white hover:bg-cyan-800"}`}
                data-testid={joined ? "gift-cards-waitlist-leave" : "gift-cards-notify-me"}>
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : joined ? <BellRing className="w-4 h-4" /> : <Bell className="w-4 h-4" />}
          {joined ? "Stop notifying me" : "Notify me"}
        </button>
      </div>
      {joined && <WaitlistBrandPicks key={info.joined_at} brands={info.brands || []} picks={info.picks || []} max={info.max_picks || 3} />}
    </section>
  );
};
